import React, {useEffect, useState} from "react";
import ApiDatabase from "../../server";
import {toast} from "react-toastify";
import UseContext from "../../hooks/useContext";
import {NegativeThumb, PositiveThumb} from "../../assets/icons";
import Badge from "../badge/badge";
import ExternalTooltip from "../tooltips/ExternalTooltip";
import useModal from "../modal/useModal";
import Button from "../button";

const RatingTempWorker = ({review, isTutoCanBeDisplayed, idMission, idTempWorker, idTimeSheet}) => {
    const {userDatas, companyData, setIdTempWorker, setIdMission, setIdTimeSheet, updateRatingTempWorker, setUpdateRatingTempWorker} = UseContext()
    const [reviewTempWorker, setReviewTempWorker] = useState(review || null)
    const [isLoading, setIsLoading] = useState(!review)
    const {toggle}=useModal()

    const [confirmTutoRateProfileCompany, setConfirmTutoRateProfileCompany] = useState(false);
    const [onClickConfirm, setOnClickConfirm] = useState(false);

    // Charger la review au montage si elle n'est pas fournie en prop
    useEffect(() => {
        if(!review && localStorage.getItem('xsrfToken') && companyData?._id && idTempWorker && idMission){
            setIsLoading(true)
            ApiDatabase.getTempWorkerRating({ idCompany: companyData._id, idTempWorker, idMission }, (data) => {
                setReviewTempWorker(data)
                setIsLoading(false)
            }, (err) => {
                console.log(err)
                setIsLoading(false)
            })
        }
    }, [review, companyData?._id, idTempWorker, idMission]);

    useEffect(() => {
        if(onClickConfirm && !confirmTutoRateProfileCompany){
            if(localStorage.getItem('xsrfToken')){
                ApiDatabase.putCheckTutoRateProfileCompany({}, (data) => {
                    setConfirmTutoRateProfileCompany(true)
                }, (err) => {
                    setConfirmTutoRateProfileCompany(false)
                })
            } else {
                toast.error('Une erreur est survenue, veuillez réessayer plus tard.')
            }
        }
    }, [onClickConfirm]);

    useEffect(() => {
        if(Object.keys(userDatas).length > 0){
            setConfirmTutoRateProfileCompany(userDatas.tutoRateProfileCompany ?? false)
        }
    }, [userDatas]);

    const toggleModalRatingTempWorker = () => {
        if(idTempWorker) setIdTempWorker(idTempWorker)
        if(idMission) setIdMission(idMission)
        if(idTimeSheet) setIdTimeSheet(idTimeSheet)
        toggle('rating_temp_worker')
    }

    useEffect(() => {
        if(updateRatingTempWorker){
            ApiDatabase.getTempWorkerRating({ idCompany: companyData?._id, idTempWorker, idMission }, (data) => {
                setReviewTempWorker(data)
                setUpdateRatingTempWorker(false)
            }, (err) => {
                console.log(err)
            })
        }
    }, [updateRatingTempWorker]);

    return (
        <>
            {reviewTempWorker ? (
                <>
                    {
                        reviewTempWorker.type ? (
                            reviewTempWorker.type === 'positive' ? (
                                <Button 
                                    size="XS" 
                                    color="DEFAULT"
                                    onClick={() => toggleModalRatingTempWorker()}
                                >
                                    <div className="flex items-center gap-2">
                                        <PositiveThumb wh={20} color={'#10B981'}/>
                                </div>
                                </Button>
                            ) : (
                                <Button 
                                    size="XS" 
                                    color="DEFAULT"
                                    onClick={() => toggleModalRatingTempWorker()}
                                >
                                    <div className="flex items-center gap-2">
                                        <NegativeThumb wh={20} color={'#EF4444'}/>
                                </div>
                                </Button>
                            )
                        ) : (
                            <>
                                {
                                    (confirmTutoRateProfileCompany || !isTutoCanBeDisplayed ) ? (
                                        <Button 
                                            size="XS" 
                                            color="DEFAULT"
                                            onClick={() => toggleModalRatingTempWorker()}
                                        >
                                            Retravailler
                                        </Button>
                                    ) : (
                                        <ExternalTooltip title={'Retravailler avec un candidat'}
                                                         description={'Partagez vos avis sur les candidats pour des recommandations plus ciblées pour vos futures missions.'}
                                                         confirm={confirmTutoRateProfileCompany}
                                                         setOnClickConfirm={setOnClickConfirm}
                                        >
                                            <Button 
                                                size="XS" 
                                                color="DEFAULT"
                                                onClick={() => toggleModalRatingTempWorker()}
                                            >
                                                Retravailler
                                            </Button>
                                        </ExternalTooltip>
                                    )
                                }
                            </>
                        )
                    }
                </>
            ) : (
                <>
                    {
                        (confirmTutoRateProfileCompany || !isTutoCanBeDisplayed ) ? (
                            <Button 
                                size="XS" 
                                color="DEFAULT"
                                onClick={() => {
                                    if(idTempWorker) setIdTempWorker(idTempWorker)
                                    if(idMission) setIdMission(idMission)
                                    if(idTimeSheet) setIdTimeSheet(idTimeSheet)
                                    toggle('rating_temp_worker')
                                }}
                            >
                                Retravailler
                            </Button>
                        ) : (
                            <ExternalTooltip title={'Retravailler avec un candidat'}
                                             description={'Partagez vos avis sur les candidats pour des recommandations plus ciblées pour vos futures missions.'}
                                             confirm={confirmTutoRateProfileCompany}
                                             setOnClickConfirm={setOnClickConfirm}
                            >
                                <Button 
                                    size="XS" 
                                    color="DEFAULT"
                                    onClick={() => {
                                        if(idTempWorker) setIdTempWorker(idTempWorker)
                                        if(idMission) setIdMission(idMission)
                                        if(idTimeSheet) setIdTimeSheet(idTimeSheet)
                                        toggle('rating_temp_worker')
                                    }}
                                >
                                    Retravailler
                                </Button>
                            </ExternalTooltip>
                        )
                    }
                </>
            )}
        </>
    )
}

export default RatingTempWorker;